const $ = jQuery;

class Button {
	constructor(el, config){
		this.el = el;
		this.config = config;
		this.playlistItem = this.findPlaylistItem();
		if( !this.playlistItem ){
			return;
		}
		this.el.innerHTML = '<button class="mb-2 btn btn-primary">Play <span class="mdi mdi-play"></span></button>';
		this.button = this.el.querySelector('button');
		this.el.addEventListener('click', () => this.play(), false);

		// also find the appropriate audio for this and listen for events
		this.audio = this.findAudio();
		this.addEvents();
	}

	findPlaylistItem(){
		let item = document.querySelector('.playlist__item[data-episode="'+this.config.episode+'"]');
		if( !item ){
			item = document.querySelector('a[href*="podcast-player/'+this.config.episode+'/"]');
		}
		return item;
	}

	findAudio(){
		let audio = document.querySelector('audio.clip-'+this.config.episode);
		if( !audio ){
			// we need to find the 
			audio = document.querySelector('.mejs-mediaelement audio');
		}
		return audio;
	}

	addEvents(){
		console.log(this.audio);
		this.audio.addEventListener('play', (e) => this.syncPlayButton(e));
		this.audio.addEventListener('pause', (e) => this.syncPlayButton(e));
		this.audio.addEventListener('playing', (e) => this.syncPlayButton(e));
	}

	play(){
		if( this.audio.paused ){
			console.log(this.isActive());
			if( this.isActive() ){
				this.audio.play();
			}
			else {
				$(this.playlistItem).trigger('click');
			}
		}
		else {
			this.audio.pause();
		}
	}

	isActive(){
		if( this.playlistItem.classList.contains('playlist__item')  ){
			return this.playlistItem.classList.contains('active');
		}

		return this.playlistItem.getAttribute('href') == this.audio.currentSrc;
	}

	syncPlayButton(e){
		if( this.audio.paused ){
			this.setPlayButtonPlay();
		}
		else {
			this.setPlayButtonPause();
		}
	}

	setPlayButtonPlay(){
		this.button.innerHTML = 'Play <span class="mdi mdi-play"></span>';
		this.button.classList.remove('btn-secondary');
		this.button.classList.add('btn-primary');
	}

	setPlayButtonPause(){
		this.button.innerHTML = 'Pause <span class="mdi mdi-pause"></span>';
		this.button.classList.add('btn-secondary');
		this.button.classList.remove('btn-primary');
	}
}

export default {
	render(el, config){
		new Button(el, config);
	}
}